import styled from 'styled-components';

export const BannerAddEditContainerStyled = styled.div`
  .loading_show {
    width: 100%;
    height: calc(100vh - 245px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
